import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash-es/noop';
import Panel from '../../../Panel';
import SelectSearch from 'react-select-search';
import styles from './FeatureLineWeightEditor.module.scss';
import { WEIGHT_OPTIONS } from '../../../../../lib/constants';
import { findWeightLabel, findWeightIcon } from '../../../../../lib/utils';
import ChevronDown from '../../../../../assets/svg/Feather/ChevronDown';

export default function FeatureLineWeightEditor(props) {
  return (
    <Panel title='Select Weight' divider={true}>
      <SelectSearch
        options={WEIGHT_OPTIONS}
        placeholder='Weight'
        onChange={props.onChange}
        renderValue={(valueProps) => {
          return (
            <div {...valueProps} className='select-search__value-container'>
              <div className='select-search__value-label'>
                <img
                  src={findWeightIcon(
                    props.feature.properties.strokeWidth
                  )}
                  className={styles.iconSelect}
                />
                <span>
                  {findWeightLabel(
                    props.feature.properties.strokeWidth
                  )}
                </span>
              </div>
              <ChevronDown fill='#8e8e92' color='none' />
            </div>
          );
        }}
        renderOption={(optionsProps, optionData, optionSnapshot) => {
          return (
            <button {...optionsProps} className='select-search__option'>
              <img src={optionData.image} className={styles.iconSelect} />
              <span>{optionData.text}</span>
            </button>
          );
        }}
      />
    </Panel>
  );
}

FeatureLineWeightEditor.propTypes = {
  feature: PropTypes.object,
  onChange: PropTypes.func,
};

FeatureLineWeightEditor.defaultProps = {
  onChange: noop,
};
